// @flow

import * as React from 'react';

import FlexiSelect from 'app/components/commons/FlexiSelect';
import Section from 'app/components/commons/Section';
import TabSet from 'app/components/commons/TabSet';
import Responsive from 'app/components/responsive/Responsive';
import SportsFilterTab from 'app/components/sportsFilters/SportsFilterTab';

type Props = {
  onSelect: (sport: Object) => void,
  selectedSport: Object,
  sportsList: Array<*>
};

const SportsTab: React.FC<Props> = ({ onSelect, selectedSport, sportsList }: Props) => {
  const sportOptions = sportsList.map(({ id, name, subcategories }) => ({
    value: id,
    label: subcategories.length === 1 ? subcategories[0].name : name
  }));

  return (
    <Section title="Sport">
      <Responsive desktop>
        <TabSet>
          {sportsList.map(sport => (
            <SportsFilterTab
              key={sport.name}
              active={sport.id === selectedSport.id}
              disabled={sport.disabled}
              onClick={() => onSelect(sport)}
              icon={`icon-sport-${sport.icon}`}
            >
              {sport.subcategories.length === 1 ? sport.subcategories[0].name : sport.name}
            </SportsFilterTab>
          ))}
        </TabSet>
      </Responsive>
      <Responsive mobile>
        <FlexiSelect
          loading={false}
          onChange={value => onSelect(sportsList.find(s => s.id === value))}
          options={sportOptions}
          placeholder="Select a sport"
          value={selectedSport.id}
        />
      </Responsive>
    </Section>
  );
};

export default SportsTab;
